module.exports = __webpack_public_path__ + "static/media/settings.f091aa76.svg";